import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import ReactTooltip from 'react-tooltip'

export const BADGE_TYPE = {
  DANGER: 'danger',
  SUCCESS: 'success',
  WARNING: 'warning',
  INFO: 'info',
}

const Container = styled.span`
  border-radius: 999px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  padding: 1px 8px;

  ${props =>
    props.type === BADGE_TYPE.DANGER
      ? `
      background: rgba(170, 71, 0, 0.2);
      color: #AA4700;
      `
      : props.type === BADGE_TYPE.SUCCESS
      ? `
      background: rgba(75, 160, 62, 0.2);
      color: #0C5B00;
      `
      : props.type === BADGE_TYPE.WARNING
      ? `
      background: rgba(214, 174, 27, 0.2);
      color: #814D00;
      `
      : props.type === BADGE_TYPE.INFO
      ? `
      background: rgba(0, 43, 154, 0.1);
      color: #002B9A;`
      : ``}
`

const Badge = ({ type, tooltip, children }) => (
  <>
    <Container type={type || BADGE_TYPE.INFO} data-for={tooltip?.id} data-tip="">
      {children}
    </Container>
    {tooltip?.id && tooltip?.content && (
      <ReactTooltip id={tooltip.id} getContent={() => tooltip.content} />
    )}
  </>
)

Badge.propTypes = {
  type: PropTypes.oneOf([
    BADGE_TYPE.INFO,
    BADGE_TYPE.SUCCESS,
    BADGE_TYPE.WARNING,
    BADGE_TYPE.DANGER,
  ]),
  tooltip: PropTypes.object,
  children: PropTypes.node,
}

export default Badge
